module.exports = __webpack_public_path__ + "img/lowres-ft-banklist.ab29e537.png";